import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, useTheme } from "@mui/material";
import { FoodsIconButton } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export const ConfirmDeleteDialog = ({ open, onClose, onConfirm }: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: theme.spacing(2, 2, 2, 4),
                }}
            >
                <Typography variant="huge-bold" sx={{ marginRight: theme.spacing(2), marginTop: theme.spacing(2) }}>
                    {t("property.note.confirm_cancel_title")}
                </Typography>
                <FoodsIconButton size="m" icon="close" buttonProps={{ onClick: onClose }} />
            </DialogTitle>

            <DialogContent sx={{ padding: theme.spacing(4) }}>
                <Typography variant="body2">{t("property.note.confirm_cancel_message")}</Typography>
            </DialogContent>

            <DialogActions
                sx={{
                    alignItems: "center",
                    borderTop: `solid ${theme.palette.grey[800]} ${theme.spacing(0.1)}`,
                    padding: theme.spacing(4),
                    gap: theme.spacing(2),
                    flexDirection: "column",
                }}
            >
                <Button sx={{ width: "100%" }} onClick={onConfirm} variant="primary">
                    <Typography variant="big-bold" sx={{ color: theme.palette.common.white }}>
                        {t("glossary.confirm_delete")}
                    </Typography>
                </Button>

                <Button sx={{ width: "100%" }} onClick={onClose} variant="ternary">
                    <Typography variant="big-bold">{t("glossary.cancel_delete")}</Typography>
                </Button>
            </DialogActions>
        </Dialog>
    );
};
